import { GetExtension } from "./GetExtension";

export function IsOrgChartFile(fileName) {
  var fileExt = GetExtension(fileName);
  var isOC5 = fileExt == "oc5" || fileExt == "ocd";
  return isOC5;
}
